// useVersionCheck.ts
import { useEffect, useRef, useState } from "react";

export function useVersionCheck(intervalMs = 60000) {
  const [hasUpdate, setHasUpdate] = useState(false);
  const current = useRef<string | null>(import.meta.env.VITE_APP_BUILD ?? null);

  useEffect(() => {
    let timer: number | null = null;

    const check = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (res.ok) {
          const data = await res.json();
          const incoming = data?.version?.toString();
          if (incoming && current.current && incoming !== current.current) {
            window.location.reload();
          }
        }
      } catch { }
    };

    // primera consulta y luego polling
    check();
    timer = window.setInterval(check, intervalMs);

    return () => { if (timer) window.clearInterval(timer); };
  }, [intervalMs]);

  return { hasUpdate, reload: () => window.location.reload() };
}
